// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__CdhpC","spinner":"Loader_spinner__vfeBl","spin":"Loader_spin__vIB6q","dark":"Loader_dark__gjJnY"};